module.exports = __webpack_public_path__ + "img/hr-reactor-shadow.8f08dece.png";